import { render } from "./PatientsDatatableFormMPhone2.vue?vue&type=template&id=568b3d6a"
import script from "./PatientsDatatableFormMPhone2.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableFormMPhone2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__